module.exports = __webpack_public_path__ + "static/custom-tooltips-ada36249ec878c62ae2b8735fdf68939.png";